function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React, { Component } from "react";
import "./index.css";

var _default = /*#__PURE__*/function (_Component) {
  _inheritsLoose(_default, _Component);

  function _default() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = _default.prototype;

  _proto.render = function render() {
    if (this.props.Active) {
      if (this.props.Active && this.props.Pulse) {
        return React.createElement("status-indicator", {
          Active: "",
          pulse: ""
        });
      }

      return React.createElement("status-indicator", {
        active: ""
      });
    } else if (this.props.Positive) {
      if (this.props.Pulse) {
        return React.createElement("status-indicator", {
          positive: "",
          pulse: ""
        });
      }

      return React.createElement("status-indicator", {
        positive: ""
      });
    } else if (this.props.Intermediary) {
      if (this.props.Pulse) {
        return React.createElement("status-indicator", {
          intermediary: "",
          pulse: ""
        });
      }

      return React.createElement("status-indicator", {
        intermediary: ""
      });
    } else if (this.props.Negative) {
      if (this.props.Pulse) {
        return React.createElement("status-indicator", {
          negative: "",
          pulse: ""
        });
      }

      return React.createElement("status-indicator", {
        negative: ""
      });
    } else {
      return React.createElement("status-indicator", {});
    }
  };

  return _default;
}(Component);

export { _default as default };